import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";
import Loader from "common/components/Loader";
import Header from "common/js/header/header";
import "common/css/master.css";
import { subjectDaysPeriodListSvc, getClassListSvc, getSectionListSvc, periodListSvc } from './subjectConstraintSvc';
import SubjectConstraintTable from './subjectConstraintTbl';

var vLstSub = []
const SubjectConstraintCtrl = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [lstPeriod, setLstPeriod] = useState([])
    const [lstCls, setLstCls] = useState([]);
    const [clsId, setClsId] = useState(null);
    const [lstSection, setLstSection] = useState([]);
    const [selSectionId, setSelSectionId] = useState(null);
    const [randNo, setRandNo] = useState(0);
    const [lstSub, setLstSub] = useState(null);
    const [syllabusId, setSyllabusId] = useState(0);
    const [tblKey, setTblKey] = useState(0)
    const [lstOrigSub, setLstOrigSub] = useState([])



    useEffect(() => {
        // console.log("SubjectConstraintCtrl called");
        setClass();
    }, []);


    const updateTblKey = (keyVal) => {
        // console.log('keyVal = ', keyVal)
        setTblKey(keyVal)
    }

    const getSubjectDaysPeriodList = (pSectionId) => {
        // console.log("getSubjectDaysPeriodList called");
        setLoader("block");
        setOpacity(0.5);
        subjectDaysPeriodListSvc(pSectionId, subjectDaysPeriodListResponse);
    }

    const subjectDaysPeriodListResponse = (data, pSectionId) => {
        // console.log("subjectDaysPeriodListResponse called, data", data);
        if (data.status === "Success") {
            // setLstSub(data.lstSubject);
            vLstSub = data.lstSubject;
            setLstOrigSub(vLstSub)
            getPeriodList(pSectionId);

        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }
    const processDaysPeriodOff = (pLen, pLstSub) => {
        let tmpSubjects = pLstSub.map(subject => {
            
            return {
                ...subject
                , lstDaysOff: (subject.daysOff || '0000000').split('').map(ch => ch == "1")
                , lstPeriodsOff: (subject.periodsOff || '000000000000000').substring(0, pLen).split('').map(ch => ch == "1")
                , periodsOff: (subject.periodsOff || '000000000000000').substring(0, pLen)
                , daysOff: (subject.daysOff || '0000000')
            };
        });
        setLstSub(tmpSubjects)
        updateTblKey(Math.round(Math.random() * 99999))
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    function setClass() {
        getClassListSvc(handleClassResponse);
    }

    function handleClassResponse(data) {
        var obj = data;
        if (obj.SvcStatus == 'Success') {
            setLstCls(obj.lstCls);
        } else if (obj.SvcStatus == 'Failure') {
            if (obj.SvcMsg === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.SvcMsg === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.SvcMsg);
            }
        } else {
            toast.error("Service failed " + obj.SvcMsg);
        }
    }

    function handleClsChange(e) {
        // console.log("handleClassChange() called, parameter passed vClsId = e.target.value", e.target.value);

        var vClsId = e.target.value;
        setClsId(vClsId)
        setSelSectionId(0)
        setSection(vClsId);
        generateRandomNo();
    }

    function setSection(pClsId) {
        getSectionListSvc(handleSectionResponse, pClsId);
    }

    function handleSectionResponse(data) {
        var obj = data;
        if (obj.SvcStatus == 'Success') {
            setLstSection(obj.lstClassSection);
            // console.log("obj in handle SectionResponse", obj);
            // console.log("obj.lstClassSection", obj.lstClassSection);
            if (obj.lstClassSection && obj.lstClassSection.length > 0) {
                changeSection(obj.lstClassSection[0]);
            }
        } else if (obj.SvcStatus == 'Failure') {
            if (obj.SvcMsg === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.SvcMsg === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.SvcMsg);
            }
        } else {
            toast.error("Service failed " + obj.SvcMsg);
        }
    }

    async function changeSection(pSection) {
        // console.log("changeSection called, pSection", pSection);
        await setSelSectionId(pSection.sectionId);

        getSubjectDaysPeriodList(pSection.sectionId);
        setSyllabusId(pSection.syllabusId);
        generateRandomNo()
    }
    const getPeriodList = (pSecId) => {
        periodListSvc(pSecId, periodListResponse)
    }
    const periodListResponse = async (data) => {
        // console.log("subjectDaysPeriodListResponse called, data", data);
        if (data.status === "Success") {
            // console.log(data.lstPeriod[0].disabled)
            await setLstPeriod(data.lstPeriod);
            // console.log(vLstSub)
            processDaysPeriodOff(data.lstPeriod.length, vLstSub)
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }
    function generateRandomNo() {
        var lRandNo = Math.floor(Math.random() * 999999);
        // console.log(lRandNo)
        setRandNo(lRandNo)
    }





    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div
                className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: loader === "none" ? 'pointer' : 'none',
                    pointerEvents: loader === "none" ? 'auto' : 'none',
                    opacity: opacity
                }}
            >
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-centered padding-remove" style={{ marginTop: "15px" }}>
                    {/*  <div className="col-sm-12 col-md-12 padding-remove"
                        style={{ width: '94%', margin: '2% ', background: '#fff', border: '1px solid #ccc', borderRadius: 10 }}> */}
                    <form
                        id="editManualAllocationForm"
                        className='form form-horizontal'
                        style={{ height: "90vh", maxHeight: "600px", padding: "20px 20px 5px 20px", }}
                    >
                        <div className="col-md-10 col-sm-10 col-centered">
                            <div className="">
                                <div className="col-sm-3" style={{ paddingRight: 0 }}>
                                    <div className="form-group col-sm-9 padding-remove">
                                        <select autoComplete="off" name="classId" id="classesCmb"
                                            type="text" className="form-control"
                                            onChange={handleClsChange}
                                        >
                                            <option value="0" >Class</option>
                                            {lstCls.map((obj) => (
                                                <option value={obj.classId}
                                                    key={obj.classId} id={obj.classId} >{obj.classLabel}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-9 padding-remove">
                                    <div className="tab form-group padding">
                                        {lstSection.map((obj) => {
                                            var isSelected = obj.sectionId === selSectionId;
                                            return <div style={{
                                                height: 34, display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }} className={isSelected ? "sellected" : ""} onClick={(e) => changeSection(obj)} key={obj.sectionId}>
                                                <span hidden>{obj.sectionId}</span>
                                                <span>{obj.section}</span>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-12 padding-remove">
                                {lstSub && lstSub.length && selSectionId && <SubjectConstraintTable
                                    key={tblKey}
                                    tblKey={tblKey}
                                    lstSub={lstSub}
                                    syllabusId={syllabusId}
                                    clsId={clsId}
                                    sectionId={selSectionId}
                                    setLoader={setLoader}
                                    setOpacity={setOpacity}
                                    lstPeriod={lstPeriod}
                                    getSubjectDaysPeriodList={getSubjectDaysPeriodList}
                                />}
                            </div>
                        </div>
                    </form>
                    {/* </div> */}
                </div>
            </div >
        </div>
    );
}

export default SubjectConstraintCtrl;

